export default "/images/arrow-long-right.svg?4a26046597c4188c21bade97e8990780";